import { StyledText } from 'src/pages/DUPPage/styles';
import styled from 'styled-components';

export const CollapsibleText = styled(StyledText)`
  color: ${({ theme }) => theme.redesignColor.gray[500]};
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  margin: 0.5rem;
  &:hover {
    color: ${({ theme }) => theme.redesignColor.snappt[500]};
  }
`;

export const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: #d9d9d9; /* Light gray, adjust as needed */
`;

export const CollapsibleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
